import { useState } from 'react';
import { loginStaff } from '../firebase/auth';

function LoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await loginStaff(email, password);
    
    if (result.success) {
      window.location.href = '/';
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-salon-bg flex items-center justify-center">
      <div className="w-full max-w-5xl mx-4 flex flex-col md:flex-row bg-white rounded-xl shadow-xl overflow-hidden">
        {/* Left Panel - Branding */}
        <div className="md:w-1/2 bg-salon-bg flex flex-col items-center justify-center p-8 md:p-12">
          <div className="text-center">
            <img 
              src="/images/logo-white.png" 
              alt="Muse & Mane" 
              className="w-48 md:w-64 mx-auto transform scale-110" 
            />
            <h2 className="text-white text-2xl font-light mt-6 tracking-wide">Salon Management</h2>
            <p className="text-gray-300 text-sm mt-2">Client records & consent</p>
          </div>
        </div>

        {/* Right Panel - Form */}
        <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center">
          <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">Welcome Back</h1>
          <p className="text-center text-gray-500 mb-8">Sign in to continue</p>

          {error && (
            <div className="bg-red-100 text-red-700 p-3 rounded-md mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-salon-button"
                placeholder="staff@museandmane.com"
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-salon-button"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-salon-button text-white py-2 rounded-md hover:bg-salon-button-hover disabled:opacity-50 transition"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;